
export const Helper = {
    Arrays: {
        AreEuqal: (a: string[], b: string[]) =>
            a.length === b.length &&
            a.every((value, index) => value === b[index])
    }
}